import { styled, Icon as IconBase } from '@innowise-group/mui-kit';

export const FormContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.75rem;
`;

export const NonBillableWarning = styled.div`
  display: flex;
  padding: 1rem;
  align-items: center;
  gap: 0.75rem;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #fee6d8;
  background: #fef2ec;
  color: ${({ theme }) => theme.palette.general.darkGrey[100]};
  font-size: 1rem;
  font-weight: 400;
`;

export const AlertIcon = styled(IconBase)`
  width: 20px;
  height: 20px;
`;
